/**
 * Simple template text expander.
 *
 * A template is a string containing placeholder strings surrounded by a
 * delimiter string (one or multiple characters). The default delimiter string
 * is '#'.
 *
 * The template expander replaces placeholders by variable values using
 * `expand`.
 *
 * @param {string} [spec.delimiter] - Delimiter string surrounding variables.
 */
export default class TemplateExpander {
	constructor({ delimiter = "#" } = {}) {
		this._delimiter = delimiter;
	}

	expand(template, variables) {
		return Object.keys(variables).reduce(
			(acc, key) => this._expandVariable(acc, key, variables[key]),
			template,
		);
	}

	_expandVariable(template, key, value) {
		return template.replace(
			new RegExp(`${this._delimiter}${key}${this._delimiter}`, "g"),
			value,
		);
	}
}
